import { CaseReducer, createSlice } from '@reduxjs/toolkit';

interface ModalState {
  isOpen: boolean;
  message: string | React.ReactElement | null;
  closeMessage: string | React.ReactElement | null | undefined;
  confirmMessage: string | React.ReactElement | null | undefined;
  onClose: (() => void) | null;
  onConfirm: (() => void) | null;
  width: string | undefined;
  hideCancel: boolean | undefined;
}

type PayloadType = Omit<
  ModalState,
  'isOpen' | 'closeMessage' | 'confirmMessage' | 'width' | 'hideCancel'
> &
  Partial<Pick<ModalState, 'closeMessage' | 'confirmMessage' | 'width' | 'hideCancel'>>;

const modalSlice = createSlice<
  ModalState,
  {
    showModal: CaseReducer<
      ModalState,
      {
        type: string;
        payload: PayloadType;
      }
    >;
    hideModal: CaseReducer<ModalState>;
  }
>({
  name: 'modal',
  initialState: {
    isOpen: false,
    message: null,
    closeMessage: null,
    confirmMessage: null,
    onClose: null,
    onConfirm: null,
    width: undefined,
    hideCancel: undefined,
  },
  reducers: {
    showModal: (
      state,
      { payload: { message, closeMessage, confirmMessage, onClose, onConfirm, width, hideCancel } },
    ) => ({
      isOpen: true,
      message,
      closeMessage,
      confirmMessage,
      onClose,
      onConfirm,
      width,
      hideCancel,
    }),
    hideModal: () => ({
      isOpen: false,
      message: null,
      closeMessage: null,
      confirmMessage: null,
      onClose: null,
      onConfirm: null,
      width: undefined,
      hideCancel: undefined,
    }),
  },
});

export const { showModal, hideModal } = modalSlice.actions;

export default modalSlice.reducer;
